export const PRIMARY_COLOR = '#00132c';
export const ACTIVE_COLOR = '#2592ea';
export const TEXT_LIGHT = '#adbad7';
export const POSITIVE_COLOR = '#02ceb1';
export const NEGATIVE_COLOR = '#f00b3f';
export const GREY = '#85919D';
export const LIGHT_MODE = '#EBF0F7';
export const WHITE = '#FFFFFF';
export const DARK_LIGHT = "#0B243E";

export const RECTANGLE_BLUE = [
  { offset: "0%", stopColor: "#50C1F5" },
  { offset: "10%", stopColor: "#4DBDF4" },
  { offset: "20%", stopColor: "#48B8F3" },
  { offset: "30%", stopColor: "#44B4F1" },
  { offset: "40%", stopColor: "#40AFF0" },
  { offset: "50%", stopColor: "#40AFF0" },
  { offset: "60%", stopColor: "#38A6EF" },
  { offset: "70%", stopColor: "#36A4EF" },
  { offset: "80%", stopColor: "#35A3EE" },
  { offset: "90%", stopColor: "#2D9BEC" },
  { offset: "100%", stopColor: "#2895EB" },
];

export const RECTANGLE_VIOLET = [
  { offset: "0%", stopColor: "#9265CD" },
  { offset: "10%", stopColor: "#9164CB" },
  { offset: "20%", stopColor: "#8C60C5" },
  { offset: "30%", stopColor: "#8A5EC1" },
  { offset: "40%", stopColor: "#8A5EC1" },
  { offset: "50%", stopColor: "#8A5EC1" },
  { offset: "60%", stopColor: "#8A5EC1" },
  { offset: "70%", stopColor: "#8A5EC1" },
  { offset: "80%", stopColor: "#8257B7" },
  { offset: "90%", stopColor: "#7F55B3" },
  { offset: "100%", stopColor: "#7B53AF" },
];

export const TOPICS_CELL_WIDTH_REPARTITION = [
  15, 15.7, 13, 14, 20, 20
];

export const DEFAULT_LOGIN = {
  email: 'demo@xbrain.io',
  password: 'B?Nn*U@2xtL3w5m7',
}
